import * as Yup from 'yup';

export const leaveRequestFormSchema = Yup.object().shape({
});
